import * as React from 'react';
import "rxjs/add/observable/from";
import * as classNames from "classnames";
import { withTheme } from '../../../common/withTheme';
import { FooterPropsAndActions } from './Footer';
import InternalClassificationLink from '../../Framework/Common/Links/InternalClassificationLink';

class FooterPlatypus extends React.PureComponent<FooterPropsAndActions, any> {

    render() {
        return (
            <footer
                className={classNames(
                    this.props.theme,
                    "footer"
                )}
            >
                <div className={classNames(this.props.theme, "footer-content container py-4")}>
                    <div className="footer-logo">
                    </div>
                    <div className="footer-text">
                        <div className="footer-links">
                            <a rel="noopener" href="https://www.facebook.com/Australian-Platypus-Conservancy-Official-225816770830721/" target="_blank">Our Facebook page</a>
                            {" "}
                            {InternalClassificationLink("legal-privacy-policy", "Legal/Privacy Policy", undefined, undefined)}
                        </div>
                        <div className="footer-copyright">
                            © {new Date().getFullYear()} Australian Platypus Conservancy
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default withTheme<FooterPropsAndActions>(FooterPlatypus);